import { render, staticRenderFns } from "./PostSearchLimitedPrintQueueUser.vue?vue&type=template&id=528dbbd0&"
import script from "./PostSearchLimitedPrintQueueUser.vue?vue&type=script&lang=js&"
export * from "./PostSearchLimitedPrintQueueUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports